import React from 'react';
import { Card as MuiCard, CardProps } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledCard = styled(MuiCard)<CardProps>(({ theme }) => ({}));

const Card = React.forwardRef<HTMLDivElement, CardProps>((props, ref) => {
  return <StyledCard ref={ref} {...props} />;
});

Card.displayName = 'Card';

export default Card;
